/**
 * Outgoing newsletter From / Reply-To (Postmark edge secrets).
 * Keep in sync with DEFAULT_SENDER_EMAIL and DEFAULT_REPLY_TO on Supabase.
 */
export const NEWSLETTER_SENDER_FROM = 'Stephan Smith <newsletter@mail.stephansmith.me>';
export const NEWSLETTER_SENDER_REPLY_TO = 'stephan@stephansmith.me';
